export var Status;
(function (Status) {
    Status["Info"] = "info";
    Status["Success"] = "success";
    Status["Warning"] = "warning";
    Status["Error"] = "critical";
})(Status || (Status = {}));
export function isLinkAction(action) {
    return Object.hasOwn(action, 'link');
}
export function isNewer(prev, next) {
    return next.modifiedOn && (!prev.modifiedOn || prev.modifiedOn < next.modifiedOn);
}
//# sourceMappingURL=common.js.map